<template>
  <b-row style="margin-top: 5rem">
    <b-col cols="12" class="mt-3 d-flex justify-content-center">
      <span class="pcg-dark-gray-color">{{ $t('views.new_password.instructions') }}</span>
    </b-col>
    <b-col cols="12" class="mt-3 d-flex justify-content-center">
      <pcg-text-input class="col-6"
                      autocomplete="on"
                      type="password"
                      name="password"
                      :label="$t('components.abk_user_registration_form.password')"
                      v-model="password"/>
    </b-col>
    <b-col cols="12" class="mt-3 d-flex justify-content-center">
      <pcg-btn class="save-button mr-0" size="small" @click="savePassword()">{{ $t('views.new_password.save') }}</pcg-btn>
    </b-col>
  </b-row>
</template>

<script>
import ApiUsers from '../api/users'
import { mapGetters } from 'vuex'

export default {
  name: 'new-password',
  data () {
    return {
      password: null,
      token: null
    }
  },
  created () {
    this.token = this.$route.query.token
    this.hideAppLoader()
  },
  watch: {
    contrast (newValue) {
      newValue ? this.clearBackgroundImage() : this.setBackgroundImage()
    }
  },
  computed: {
    ...mapGetters('page', ['contrast'])
  },
  methods: {
    savePassword () {
      ApiUsers.savePassword({ token: this.token, password: this.password })
        .then((response) => {
          this.$toastr.s(this.$t('views.new_password.password_saved'))
          this.$router.push({ name: 'login_user_path' })
        })
        .catch(error => {
          if (error.response.data.token) {
            this.$toastr.e(error.response.data.token)
            this.errors = error.response.data.token
            this.$router.push({ name: 'reset_password_path' })
          }
          if (error.response.data.password) {
            this.$toastr.e(error.response.data.password)
            this.errors = error.response.data.password
          }
        })
    },
    setHeader () {
      this.$store.dispatch('header/setHeader', {
        title: this.$t('views.new_password.title'),
        subtitle: this.$t('views.new_password.subtitle')
      })
    },
    hideAppLoader () {
      setTimeout(() => {
        document.getElementById('app-loader').style.display = 'none'
      }, 500)
    },
    setBackgroundImageStyle () {
      this.$store.dispatch('pageCover/setBackgroundImageStyle', {
        height: '100% !important'
      })
    },
    setBackgroundImage () {
      if (!this.contrast) {
        this.$store.dispatch('pageCover/setBackgroundImage', require('../assets/images/Blank.jpeg'))
      }
    },
    setBackgroundImageClasses () {
      this.$store.dispatch('pageCover/setBackgroundImageClasses', ['no-gradient'])
    },
    setSidebarMenuClasses () {
      this.$store.dispatch('sidebarMenu/setSidebarMenuClasses', ['no-box-shadow'])
    },
    clearBackgroundImage () {
      this.$store.dispatch('pageCover/clearBackgroundImage')
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setBackgroundImage()
      vm.setBackgroundImageStyle()
      vm.setBackgroundImageClasses()
      vm.setSidebarMenuClasses()
    })
  }
}
</script>

<style scoped>

</style>
